import { useState } from "react";
import { Spin } from "antd";

const ArchivoOrdenDePago = ({ archivo, callback }) => {

    const [loading, setLoading] = useState(false)

    return (
        <div onClick={() => callback(archivo, setLoading)} style={{ cursor: "pointer", textDecoration: "underline" }}>
            <Spin tip="Cargando archivo..." spinning={loading} size="small">
                <p>{`${archivo.name}${archivo.extension}`}</p>
            </Spin>
        </div>
    );
}

export default ArchivoOrdenDePago;